import Loadable from "react-loadable";

const LazyLivrableEvaluate = Loadable({
  loader: () => import(/* webpackChunkName: 'livrable-evaluate' */ "./Evaluate"),
  loading: () => 'loading...'
});

export default LazyLivrableEvaluate;
